<template>
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide :key="index" v-for="(image, index) in images">
      <img :src="image" alt="" />
    </swiper-slide>

    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "swiper-example-pagination-progress",
  title: "Progress pagination",
  props: ["images"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.swiper {
  border-radius: 0.8rem;

  width: 100%;
  height: 100%;
  overflow: hidden;
}
.swiper-pagination.swiper-pagination-progressbar {
  width: 94% !important;
  margin-left: 3% !important;
  bottom: 1px !important;
  border-radius: 20px !important;
  top: initial;
}
// @import "./base.scss";
</style>
